import { ThemeEvents } from '@theme/events';

/**
 * Cart drawer updates morph HTML in place. The slideshow custom element doesn't
 * reliably re-initialize when its internal slides are morphed, so we force a
 * reconnect by cloning/replacing the upsell slideshow after cart updates.
 */
function refreshCartUpsellSlideshows() {
  try {
    const slideshows = document.querySelectorAll('slideshow-component[data-cart-upsell-slideshow="true"]');
    if (!slideshows?.length) return;

    slideshows.forEach((slideshow) => {
      // DOM may change mid-loop during cart morphs; guard every step.
      if (!(slideshow instanceof HTMLElement) || !slideshow.isConnected) return;
      const parent = slideshow.parentNode;
      if (!parent) return;

      const clone = /** @type {HTMLElement} */ (slideshow.cloneNode(true));
      parent.replaceChild(clone, slideshow);
    });
  } catch {
    // Never block cart updates if upsell isn't present/ready.
  }
}

function scheduleCartUpsellRefresh() {
  // Cart drawer updates can be async/multi-step (fetch → morph → layout).
  // Re-try a few times to catch late DOM replacements.
  try {
    requestAnimationFrame(() => requestAnimationFrame(refreshCartUpsellSlideshows));
    setTimeout(refreshCartUpsellSlideshows, 50);
    setTimeout(refreshCartUpsellSlideshows, 200);
    setTimeout(refreshCartUpsellSlideshows, 500);
  } catch {
    // noop
  }
}

document.addEventListener(ThemeEvents.cartUpdate, scheduleCartUpsellRefresh);

